var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiCopyOutlineRtl = function SvgUiCopyOutlineRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 102,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.005 79.982c0 .621-.534 1.146-1.166 1.146h-1.453V88h1.453c4.5 0 8.161-3.597 8.161-8.018V8.018C86 3.596 82.34 0 77.839 0H32.16C27.661 0 24 3.596 24 8.018v1.665h6.995V8.018c0-.621.534-1.146 1.166-1.146H77.84c.632 0 1.166.525 1.166 1.146z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M65.839 102H20.16c-4.5 0-8.161-3.597-8.161-8.018V22.018C12 17.596 15.661 14 20.161 14H65.84c4.5 0 8.161 3.596 8.161 8.018v71.964c0 4.421-3.66 8.018-8.161 8.018m1.166-79.982c0-.621-.534-1.146-1.166-1.146H20.16c-.632 0-1.166.525-1.166 1.146v71.964c0 .621.534 1.146 1.166 1.146h45.68c.632 0 1.166-.525 1.166-1.146z",
    clipRule: "evenodd"
  })));
};
export default SvgUiCopyOutlineRtl;